// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.license-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  color: white;
  font-weight: 500;
  width: 100%;
  box-sizing: border-box;
  z-index: 1000;
}

.banner-trial {
  background-color: #1976d2; /* Blue for trial */
}

.banner-expired {
  background-color: #d32f2f; /* Red for expired */
}

.banner-button {
  background-color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 12px;
  cursor: pointer;
  font-weight: bold;
  margin-left: 16px;
  color: #333;
}
.banner-button:hover {
  background-color: #f5f5f5;
}`, "",{"version":3,"sources":["webpack://./src/app/components/license-banner/license-banner.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;AACF;;AAEA;EACE,yBAAA,EAAA,mBAAA;AACF;;AAEA;EACE,yBAAA,EAAA,oBAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;AACF;AACE;EACE,yBAAA;AACJ","sourcesContent":[".license-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 16px;\n  color: white;\n  font-weight: 500;\n  width: 100%;\n  box-sizing: border-box;\n  z-index: 1000;\n}\n\n.banner-trial {\n  background-color: #1976d2; /* Blue for trial */\n}\n\n.banner-expired {\n  background-color: #d32f2f; /* Red for expired */\n}\n\n.banner-button {\n  background-color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 4px 12px;\n  cursor: pointer;\n  font-weight: bold;\n  margin-left: 16px;\n  color: #333;\n  \n  &:hover {\n    background-color: #f5f5f5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
